// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"K9-z"};